export default "__VITE_ASSET__C7UHn2LZ__"